import { OrdersView } from "./orders-view";
import { CreateOrderButton } from "./create-order-button";
import { DashboardStats } from "./dashboard-stats";
import { DashboardMobileHero } from "./dashboard-mobile-hero";
import { useTranslation } from "react-i18next";

export default function OrdersScreen() {
  const { t } = useTranslation("app");

  return (
    <div className="space-y-6">
      {/* Mobile: editorial hero w/ date eyebrow + count headline + actions.
          Design frame 6 · Dashboard. Desktop header is the inline stat strip. */}
      <DashboardMobileHero />

      <div className="hidden md:block border-b border-default-200 pb-6">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between lg:gap-6">
          <div className="flex flex-col md:flex-row md:items-baseline md:gap-7 min-w-0 shrink">
            <h1 className="text-2xl font-bold tracking-tight shrink-0">
              {t("orders.title")}
            </h1>
            <DashboardStats />
          </div>
          <div className="shrink-0 ml-auto">
            <CreateOrderButton />
          </div>
        </div>
      </div>

      <OrdersView />
    </div>
  );
}
